/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".col-md-8[_ngcontent-%COMP%]{display:flex;align-items:center;height:100vh}.card-group[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
